import { Link } from "react-router-dom";
import { LogOut, Home } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { BrandMark } from "@/components/site/BrandMark";

export const AdminTopbar = () => {
  const { user, logout } = useAuth();
  return (
    <header className="bg-[color:var(--nr-bg)]/90 backdrop-blur-xl border-b border-[color:var(--nr-line)] sticky top-0 z-30">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex flex-col items-start gap-1" data-testid="admin-logo">
          <BrandMark className="w-6 h-6 text-[color:var(--nr-accent)]" />
          <div className="leading-tight">
            <div className="font-serif-display text-lg text-[color:var(--nr-ink)] leading-none">
              noah<span className="text-[color:var(--nr-accent)]">+</span>rayn
            </div>
            <div className="text-[0.6rem] uppercase tracking-[0.2em] text-[color:var(--nr-ink-soft)] mt-1">
              Admin
            </div>
          </div>
        </Link>
        <div className="flex items-center gap-3">
          <Link
            to="/"
            data-testid="admin-view-site"
            className="hidden sm:inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-[color:var(--nr-ink-soft)] hover:text-[color:var(--nr-ink)]"
          >
            <Home size={14} /> View site
          </Link>
          <span className="hidden md:inline text-xs text-[color:var(--nr-ink-soft)]">
            {user?.email}
          </span>
          <button
            data-testid="admin-logout"
            onClick={logout}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[color:var(--nr-line)] text-xs uppercase tracking-[0.18em] hover:bg-[color:var(--nr-bg-soft)]"
          >
            <LogOut size={14} /> Sign out
          </button>
        </div>
      </div>
    </header>
  );
};
